import React from 'react';
import { Route } from 'react-router';
import './custom.css';
import DeviceAuthentication from './components/auth/DeviceAuthentication';

const App = () => {
  return <Route path="*" component={DeviceAuthentication} />;
};
export default App;
